import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';

import { ApiService } from './api.service';
import { User } from './../models/user.model';
import { AlertService } from '../components/app-alert';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private isAuthenticated = this.getToken() ? true : false;
  private baseUrl: string = '/';

  constructor(
    private http: HttpClient,
    private api: ApiService,
    private alert: AlertService,
    private router: Router) { }

  singIn(username: string, password: string) {
    const body = new HttpParams()
      .set('username', username)
      .set('password', password)
      .set('grant_type', 'password');

    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    this.http.post(`${this.baseUrl}token`, body.toString(), { headers: httpHeaders })
      .subscribe(
        (data) => {
          localStorage.setItem('authToken', data['access_token']);
          this.api.baseUrl = this.baseUrl + 'api/';
          this.api.get<User>('loggedUser', (user) => {
            localStorage.setItem('user', JSON.stringify(user));
            this.isAuthenticated = true;
            this.router.navigate(['customers']);
          });
        },
        (error) => {
          this.alert.error(error.error.error_description);
        }
      );
  }

  signOut() {
    this.isAuthenticated = false;
    localStorage.clear();
    this.router.navigate(['login']);
  }

  isLoggedIn(): boolean {
    return this.isAuthenticated;
  }

  getToken(): string {
    return localStorage.getItem('authToken');
  }

  getLoggedUser(): User {
    let user = localStorage.getItem('user');
    let retUser: User = JSON.parse(user);
    return retUser;
  }
}
